import styled from "styled-components";
import { TableCell, TableRow } from "../BrowserTable/styles";
import colors from "../../../../../config/colors";
import { isMobile } from "../../../../../utils/common";

export const BrowserOptionsContainer = styled.div``;

export const OptionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${isMobile() &&
  `
            flex-direction:column;
            align-items:center;
        `}
`;

export const Option = styled.div`
  margin: 10px;
`;

export const TrendingSubs = styled.div`
  background-color: ${colors.darkBackground};
  ${isMobile() &&
  `
            position:fixed;
            top:53px;
            width:100vw;
        `}
`;
export const Notes = styled.div`
  padding: 5px 20px;
  font-size: 12px;
`;

export const Title = styled.div`
  padding: 10px;
  font-size: 24px;
  font-weight: bold;
`;
export const TitleLine = styled.div`
  background-color: ${colors.darkBackground};
  color: ${colors.primary};
  ${isMobile() &&
  `
    top:0px;
        position:fixed;
        width:100vw;
        display:flex;
        align-items:center;
        justify-content:space-between;
    `}
`;

export const TableHeader = styled(TableRow)`
  font-weight: bold;
  color: ${colors.darkPrimary};
  :hover {
    border: solid 1px ${colors.darkBackground};
    cursor: default;
  }
  margin-top: ${isMobile() ? 100 : 0}px;
  ${isMobile() && `font-size:2vw;`}
`;
export const TableHeaderCell = styled(TableCell)`
  display: flex;
  align-items: center;
  transition: all 0.2s;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  :hover {
    ${(props) =>
      props.sortable &&
      `
      color:${colors.primary};
      `}
  }
`;
export const CellText = styled.div`
  color: ${(props) =>
    props.active
      ? props.order === "ASC"
        ? colors.green
        : colors.red
      : colors.darkPrimary};
`;
export const SortIndicator = styled.div``;

/**
 * Replace when our stuff is back
 * 
  margin-top: ${(props) =>
    isMobile() ? (props.areOptionsOpen ? 210 : 53) : 0}px;
 */
